import React, { Component } from 'react';
import { Provider } from 'react-redux';
import store from '../../redux/store/store';

import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import * as calendarActions from '../../redux/actions/calendar';
import * as dashboardActions from '../../redux/actions/dashboard';
import * as windowSizeActions from '../../redux/actions/windowSize';
import * as plaidActions from '../../redux/actions/plaid';
import * as urlActions from '../../redux/actions/url';
import * as mealIdeaActions from '../../redux/actions/mealIdeas';
import Request from '../../utilities/Request';
import submittedTransactionFields from '../../utilities/submittedTransactionFields';

import { ToastContainer } from 'react-toastify';

import TransactionsSection from '../components/TransactionsSection';
import Category from '../../models/Category';
import CategoriesComponent from '../components/CategoriesComponent';

import { DragDropContext } from 'react-beautiful-dnd';
import { CALENDAR_DRAG_TYPE, isSlotDroppableId, mealIdeaGroupDrop } from '../components/calendar/dragTypes';
import {
	resolveCalendarDestination,
	startPointerTracking,
	stopPointerTracking,
} from '../components/calendar/pointerDropTarget';
import Tabs from '../components/Tabs';
import MonthlySpendSummary from '../components/MonthlySpendSummary';
import BudgetListModes from '../components/BudgetListModes';
import CircleLoader from '../components/CircleLoader';
import CalendarPage from './CalendarPage';
import LedgerPage from './LedgerPage';
import SettingsPage from './SettingsPage';
import getCategoryGroupsByType, {
	clearCategoryGroupCache,
	getAllCategoryGroupsHashedByType
} from '../../utilities/getCategoryGroupsByType';
import BanksSummary from "./BanksSummary.jsx";
import TransactionSummaryComponent from "../components/TransactionSummaryComponent.jsx";

import '../../utilities/serviceWorkerMessageReceiver.js';
import generateUuid from "../../utilities/generateUuid.js";
import TransactionSubmitter from "../../models/TransactionSubmitter.js";
import ServerResponseParser from "../../utilities/ServerResponseParser.js";
import AmountRemainingToBudget from "../components/AmountRemainingToBudget.jsx";
import ToastHideBankTransactionUndo from "../components/toasts/ToastHideBankTransactionUndo.jsx";
import BudgetSubmitUndo from "../components/toasts/BudgetSubmitUndo.jsx";
import TransactionEditUndo from "../components/toasts/TransactionEditUndo.jsx";
import SweetAlert from "../components/SweetAlert.jsx";
import LoginWarning from "../components/LoginWarning.jsx";
import LoginPagePopup from "./LoginPagePopup.jsx";
import Tab from "../components/navigation/Tab.jsx";
import MainNav, { SectionLink } from "../components/navigation/MainNav.jsx";
import { currentSlug, groupMembers, groupOfSlug } from "../components/navigation/sectionGroups.js";
import AppHeader from "../components/navigation/AppHeader.jsx";
import SyncStatus from "../components/SyncStatus.jsx";
import WhatsNew from "../components/whatsNew/WhatsNew.jsx";
import { updateTemporaryTransaction } from "../../redux/actions/dashboard.js";


class DashboardPage extends Component {

	constructor(props) {
		super(props);
		this.state = {
			loadPosition: 0,
			transactions: null,

			submittingCategories: {},
			submittingTransactions: {},

			refreshingData: false,

			plaidAccounts: null,
		};

		this.refreshData = this.props.refreshData;

		this.transactionFinder = this.props.transactionFinder;

		this.highlightTransaction = this.highlightTransaction.bind(this);

		this.categorySubmit = this.categorySubmit.bind(this);

		this.transactionSubmit = this.transactionSubmit.bind(this);
		this.transactionDelete = this.transactionDelete.bind(this);
		this.transactionDeleteUndo = this.transactionDeleteUndo.bind(this);

		this.categoryDelete = this.categoryDelete.bind(this);
		this.categoryDeleteUndo = this.categoryDeleteUndo.bind(this);
		this.transactionCategoryEdit = this.transactionCategoryEdit.bind(this);

		this.categoryGroupSubmit = this.categoryGroupSubmit.bind(this);
		this.categoryGroupDelete = this.categoryGroupDelete.bind(this);
		this.categoryGroupDeleteUndo = this.categoryGroupDeleteUndo.bind(this);

		this.changeActiveMonth = this.changeActiveMonth.bind(this);

		this.onDragEnd = this.onDragEnd.bind(this);
		this.onBeforeCapture = this.onBeforeCapture.bind(this);

		this.onTabClick = this.onTabClick.bind(this);

	}

	onTabClick(tab) {
		const { setSelectedMainTab } = this.props;
		setSelectedMainTab(tab);
	}

	highlightTransaction(transaction) {
		this.props.highlightTransaction(transaction);
	}

	changeActiveMonth(clickedDate, rightClickedOrSomething, event) {
		const { updateSelectedDate } = this.props;
		event.preventDefault();
		updateSelectedDate(clickedDate, rightClickedOrSomething === true || event.shiftKey);
	}

	componentDidMount() {
		this.refreshData(true);
		document.title = 'Budget!';
	}

	categoryGroupSubmit(categoryGroup, event) {
		event.preventDefault();

		let data = {};
		const deleteEdit = categoryGroup.deleteEdit;
		if(deleteEdit !== null) {
			data = {
				id: categoryGroup.id,
				['delete']: deleteEdit,
			};
		} else {
			data = {
				id: categoryGroup.id,
				name: categoryGroup.name,
				type: categoryGroup.type,
			};
		}
		const isNew = !categoryGroup.id;

		this.setState((state) => {
			const submittingCategoryGroups = { ...state.submittingCategoryGroups };
			submittingCategoryGroups[categoryGroup.id] = true;
			return {
				submittingCategoryGroups
			};
		});
		return Request.apiv1Post('budget/category_groups', data)
			.then((response) => {
				if(isNew) {
					categoryGroup.update({
						name: '',
					});
				} else {
				}
				if(categoryGroup.original) {
					categoryGroup.original.update(data.categoryGroup);
				}
				return this.refreshData();
			})
			.catch((error) => {
				Request.generalJsonError(error);
				console.error(error);
			})
			.finally(() => {
				categoryGroup.deleteEdit = null;
				this.setState((state) => {
					const submittingCategoryGroups = { ...state.submittingCategoryGroups };
					delete submittingCategoryGroups[categoryGroup.id];
					return {
						submittingCategoryGroups
					};
				});
			});
	}

	transactionCategoryEdit(transaction, newCategoryId, shouldAttemptDynamicUpdate = true) {
		transaction.category_id = newCategoryId; // Explicitly set here. NULL results in no change, 0 sets to null serverside
		if(!shouldAttemptDynamicUpdate) {
			this.forceUpdate();
			return Promise.resolve();
		}
		if(transaction.id) {
			return this.transactionSubmit(transaction);
		} else {
			if(transaction.plaid_transaction_id) {
				return Promise.resolve();
			} else {
				this.forceUpdate();
				return Promise.resolve();
			}
		}
	}

	transactionDelete(transaction, event) {
		transaction.deleteEdit = true;
		return this.transactionSubmit(transaction, event);
	}

	transactionDeleteUndo(transaction, event) {
		transaction.deleteEdit = false;
		return this.transactionSubmit(transaction, event);
	}

	categoryDelete(category, event) {
		category.deleteEdit = true;
		return this.categorySubmit(category, event);
	}

	categoryDeleteUndo(category, event) {
		category.deleteEdit = false;
		return this.categorySubmit(category, event);
	}

	categoryGroupDelete(categoryGroup, event) {
		categoryGroup.deleteEdit = true;
		return this.categoryGroupSubmit(categoryGroup, event);
	}

	categoryGroupDeleteUndo(categoryGroup, event) {
		const { submitBudgetUpdate } = this.props;
		categoryGroup.deleteEdit = true;
		return submitBudgetUpdate(categoryGroup, event);
	}

	async transactionSubmit(transaction) {
		const {
			lastEditedTransactionChanged, addTemporaryTransaction,
			endTransactionEditMode, transactionFinder
		} = this.props;
		let dateToSet = null;

		let { amount, deleteEdit, category_id, transaction_date, where, description, plaid_transaction_id } = transaction;
		if(transaction_date) {
			dateToSet = transaction_date;
		}

		let amountToSet = amount;
		if(amountToSet) {
			amountToSet = amount;
		}

		let data = {};
		if(deleteEdit !== null && deleteEdit !== undefined) {
			data = {
				id: transaction.id,
				deleted: deleteEdit,
			};
		} else {
			data = {
				id: transaction.id,
				where: where,
				description,
				amount: amountToSet,
				transaction_date: dateToSet ? dateToSet.unix() : null,
				plaid_transaction_id
			};
			if(category_id !== null && category_id !== undefined) {
				data.category_id = category_id;
			}
		}
		const isNew = !transaction.id;

		data.splits = [];

		transaction.splits.forEach((split) => {
			const splitData = {};
			splitData.category = split.category_id;
			splitData.amount = split.amount;
			splitData.id = split.id;
			data.splits.push(splitData);
		});

		this.setState((state) => {
			const submittingTransactions = { ...state.submittingTransactions };
			submittingTransactions[transaction.id] = true;
			return {
				submittingTransactions
			};
		});
		transaction.submitting = true;

		const clone = transaction.clone();
		let transactionCopy = null;
		if(transaction.id) {
			// Why is this here... could a transaction be submitted
			transactionCopy = transactionFinder.getTransactionById(transaction.id);
		}
		clone.update(submittedTransactionFields(data, transactionCopy));
		if(transaction.submit_id) {
			clone.submit_id = transaction.submit_id;
		} else {
			clone.submit_id = generateUuid();
		}
		data.submit_id = clone.submit_id;

		if(data.amount !== null && data.amount !== undefined) {
			clone.update({ amount: data.amount });
		} else if(transactionCopy?.amount !== null) {
			clone.update({ amount: transactionCopy.amount });
		}

		clone.update({
			splits: data.splits.map((split) => {
				const theSplitObject = {
					category_id: split.category,
					amount: split.amount,
					id: split.id,
				};
				return theSplitObject;
			})
		});

		if(clone.id) {
			/**
			 * Adds transaction to the update queue!
			 *
			 * Clone is the new transaction
			 */
			store.dispatch(updateTemporaryTransaction(transaction, clone,));
		} else {
			addTemporaryTransaction(clone);
		}


		const afterResponse = (response) => {
			if(isNew) {
				transaction.resetToEmpty();
			} else {
				endTransactionEditMode();
			}
			lastEditedTransactionChanged(transaction.id);
			// this.refreshData();
		};

		const finishedAction = () => {
			transaction.submitting = false;
			transaction.deleteEdit = null;
			this.setState((state) => {
				const submittingTransactions = { ...state.submittingTransactions };
				delete submittingTransactions[transaction.id];
				return {
					submittingTransactions
				};
			});
		};


		TransactionSubmitter.submit((transactionData) => {
				ServerResponseParser.transaction(transactionData);
			})
			.then(() => {
				console.log('submission done?');
			});

		return Promise.resolve()
			.then(afterResponse)
			.finally(finishedAction);
	}

	async categorySubmit(category, refreshData = true) {
		const data = {};
		data.id = category.id;
		const hadId = !!data.id;

		const { deleteEdit } = category;

		if(deleteEdit !== null) {
			data.delete = deleteEdit;
		} else {
			data.name = category.name;
			data.type = category.type;
			data.category_group_id = category.category_group_id;
			data.parent_category_id = category.parent_category_id;
			data.show_when_not_used = category.show_when_not_used;
			data.is_master_budget_for_children = category.is_master_budget_for_children;
		}

		this.setState((state) => {
			const submittingCategories = { ...state.submittingCategories };
			submittingCategories[category.id] = true;
			return {
				submittingCategories
			};
		});
		return Request.apiv1Post('budget/categories', data)
			.then(() => {
				if(hadId) {
					console.log('has original', category.original);
					if(category.original) {
						category.original.update(data.category);
					}
					category.update(data.category);
				} else {
					category.update({
						name: '',
						parent_category_id: null,
					});
				}
				return refreshData ? this.refreshData() : true;
			}, (error) => {
				// A refused save (a name clash, say) is reported, and the server's categories are
				// reloaded so the page stops showing the change that was not kept.
				return this.categorySaveRefused(error)
					.then(() => false);
			})
			.finally(() => {
				this.setState((state) => {
					const submittingCategories = { ...state.submittingCategories };
					delete submittingCategories[category.id];
					return {
						submittingCategories
					};
				});
			});
	}

	async categorySaveRefused(error) {
		console.error(error);
		alert(await Request.parseError(error));
		return this.refreshData();
	}

	updateCategorySortOrder(categoryGroup) {
		const categories = categoryGroup.getCategories();
		const list = [];
		categories.forEach((category) => {
			list.push(category.id);
		});
		return Request.apiv1Post('budget/categories', {
			sorted_list: list,
			category_group_id: categoryGroup.id,
		});
	}

	updateCategoryGroupSortOrder(categoryGroups) {
		const list = [];

		categoryGroups.forEach((categoryGroup) => {
			list.push(categoryGroup.id);
		});
		Request.apiv1Post('budget/category_groups', {
			sorted_list: list,
		});
	}

	/**
	 * The calendar opens its Other rows while something is being dragged, as drop targets. That
	 * changes the grid's layout, so it has to happen here rather than in onDragStart:
	 * react-beautiful-dnd measures every droppable once, between this and onDragStart, and a drop
	 * after the layout moved would land wherever a slot had been before it did.
	 *
	 * Which meal slot a drop lands in is read from the pointer; see pointerDropTarget.js.
	 */
	onBeforeCapture() {
		this.props.setCalendarDragging(true);
		startPointerTracking();
	}

	onDragEnd(rbdResult) {
		this.props.setCalendarDragging(false);
		const result = resolveCalendarDestination(rbdResult, stopPointerTracking());
		const { categoryGroups } = this.props;
		const { groceryListItemDrag, plaidInstitutionDrag, plaidInnerAccountDrag } = this.props;
		const { reorderMealIdeaInGroup, moveMealIdeaToGroup, addMealIdeaToGroup, reorderMealIdeaIngredient } = this.props;
		// console.log('the result', result);
		if(!result.destination) {
			return;
		}
		if(isSlotDroppableId(result.destination.droppableId)) {
			this.props.dropOnMealSlot(result);
			return;
		}
		// Reordering ingredients, a group's ideas or the grocery list is online-only; their droppables
		// take no drops offline, and this holds if one is dropped on all the same.
		if(this.props.isOnline === false && (result.type === 'MEAL_IDEA_INGREDIENTS' || result.type === CALENDAR_DRAG_TYPE)) {
			return;
		}
		const startIndex = result.source.index;
		const endIndex = result.destination.index;
		const startListId = Number.parseInt(result.source.droppableId.split('-')[1], 10);
		const endListId = Number.parseInt(result.destination.droppableId.split('-')[1], 10);

		console.log('the details', result.type, startListId, startIndex, endIndex, result);
		switch(result.type) {
			case 'MEAL_IDEA_INGREDIENTS': {
				reorderMealIdeaIngredient(startListId, startIndex, endIndex);
				break;
			}
			case CALENDAR_DRAG_TYPE: {
				// Meal ideas and grocery items share the calendar's drag type so they can reach its
				// meal slots. Off a slot, an idea can only land in a meal idea group.
				const ideaDrop = mealIdeaGroupDrop(result);
				if(ideaDrop) {
					if(ideaDrop.kind === 'reorder') {
						reorderMealIdeaInGroup(ideaDrop.groupId, ideaDrop.startIndex, ideaDrop.endIndex);
					} else if(ideaDrop.kind === 'move') {
						moveMealIdeaToGroup(ideaDrop.ideaId, ideaDrop.fromGroupId, ideaDrop.toGroupId, ideaDrop.index);
					} else {
						addMealIdeaToGroup(ideaDrop.ideaId, ideaDrop.groupId, ideaDrop.index);
					}
					break;
				}
				// Anything else landing on a grocery list, or an item on another list, is ignored.
				const isGroceryReorder = result.draggableId.startsWith('draggableGroceryListItem-')
					&& result.source.droppableId === result.destination.droppableId
					&& result.destination.droppableId.startsWith('groceryListDroppable-');
				if(isGroceryReorder) {
					groceryListItemDrag(startListId, startIndex, endIndex);
				}
				break;
			}
			case 'CATEGORY': {
				const { editBudgetListMode, selectedDates } = this.props;
				const includeCategoriesWitHNoActivity = editBudgetListMode === BudgetListModes.DASHBOARD;
				const fromList = categoryGroups.get(startListId);
				const toList = categoryGroups.get(endListId);
				const theCategories = fromList.getVisibleCategoryForMonths(selectedDates, includeCategoriesWitHNoActivity);
				const movedCategory = theCategories[startIndex];
				if(fromList === toList) {
					const reorderedList = Array.from(theCategories);
					const beforeReorder = [...reorderedList];
					const [removed] = reorderedList.splice(startIndex, 1);
					reorderedList.splice(endIndex, 0, removed);

					console.log('teh category group', fromList);

					console.log('the old list', beforeReorder);
					console.log('the new list', reorderedList);

					const theItemAfter = reorderedList[endIndex + 1];
					console.log('the item after', theItemAfter);
					const afterItemParentCategoryId = theItemAfter ? theItemAfter.parent_category_id : 0;
					if(afterItemParentCategoryId !== movedCategory.parent_category_id) {
						movedCategory.parent_category_id = afterItemParentCategoryId;
						console.log('new id', movedCategory.parent_category_id, theItemAfter);
						this.categorySubmit(movedCategory, false)
							.then((saved) => {
								if(saved === false) {
									return;
								}
								return this.updateCategorySortOrder(fromList);
							});
					} else {
						this.updateCategorySortOrder(fromList);
					}
					fromList.setCategories(reorderedList);
				} else {
					console.log('gotta move lists!');
					const sourceClone = Array.from(fromList.getVisibleCategoryForMonths(selectedDates, includeCategoriesWitHNoActivity));
					const destClone = Array.from(toList.getVisibleCategoryForMonths(selectedDates, includeCategoriesWitHNoActivity));
					const [removed] = sourceClone.splice(startIndex, 1);

					destClone.splice(endIndex, 0, removed);


					fromList.setCategories(sourceClone);
					toList.setCategories(destClone);

					Request.apiv1Post('budget/categories', {
						id: movedCategory.id,
						category_group_id: toList.id
					})
						.then(() => {
							this.updateCategorySortOrder(fromList);
							this.updateCategorySortOrder(toList);
						}, (error) => this.categorySaveRefused(error));

				}
				break;
			}
			case 'CATEGORY_GROUP': {
				const listToUse = getCategoryGroupsByType(startListId);
				const unusedList = this.getCategoryGroupsByNotType(startListId);

				const reorderedList = Array.from(listToUse);
				const [removed] = reorderedList.splice(startIndex, 1);
				reorderedList.splice(endIndex, 0, removed);


				console.log('list used', listToUse);
				console.log('removed element', removed);

				console.log('the moved', removed);
				const replacementMap = new Map();
				let currentSortOrderIndex = 0;
				reorderedList.forEach((categoryGroup) => {
					categoryGroup.sort_order = currentSortOrderIndex++;
					replacementMap.set(categoryGroup.id, categoryGroup);
				});
				unusedList.forEach((categoryGroup) => {
					replacementMap.set(categoryGroup.id, categoryGroup);
				});
				clearCategoryGroupCache();
				this.setState({
					categoryGroups: replacementMap,
				});
				this.updateCategoryGroupSortOrder(reorderedList);
				break;
			}
			case 'PLAID_INSTITUTION': {
				plaidInstitutionDrag(startIndex, endIndex);

				break;
			}
			case 'PLAID_INNER_ACCOUNT': {
				plaidInnerAccountDrag(startListId, startIndex, endIndex);
				break;
			}
			default:
				console.error('No code for ', result.type);
				return;
		}

		this.forceUpdate();
		console.log(result.source.index, result.destination.index);
	}

	getCategoryGroupsByNotType(type) {
		const { categoryGroups } = this.props;
		const categoryGroupsArray = categoryGroups ? Array.from(categoryGroups).map(([key, categoryGroup]) => {
			return categoryGroup;
		}) : null;

		return categoryGroupsArray ? categoryGroupsArray.filter((categoryGroup) => {
			return categoryGroup.type !== type;
		}) : [];
	}

	render() {
		const {
			submittingTransactions,
			submittingCategoryGroups,
			submittingCategories,

			refreshingData,
			plaidAccounts,
		} = this.state;

		const {
			budgets,
			categories,
			categoryGroups,
			player, sizeDesktop, sizeMobile, selectedDate, selectedDates, visibleDates, deleteAllTransactionsPopup,
			deleteAllTransactionsGo, deleteAllTransactionsPopupEnd,
			lastEditedTransactionId,
			showingBankAccountTransactionsWithinTransactions,
			budgetSubTabChanged,
			firstLoad,
			editBudgetListMode,
			saveAllUpdatedBudgetsForCategoryGroup,
			submitBudgetUpdate,
			submittingBudgets,
			submittingBudgetsForCategoryGroup,
			calendarFeatureActive,
			transactionBeingEdited,
			transactionBeingEditedCategoryLocked,
			endTransactionEditMode,
			transactionBeingEditedModalShouldBeOpen,
			separateBudgetTabsFeatureActive,
			url,
			activeBudget,
		} = this.props;


		if(!player) {
			console.error('REDIRECT FROM ME!');
		}

		const showCalendarTab = calendarFeatureActive || activeBudget.features.CALENDAR;

		const categoryProps = {
			...this.state,
			editBudgetListMode: editBudgetListMode,
			selectedDates: selectedDates,
			selectedDate: selectedDate,
			budgets: budgets,
			categories: categories,
			categoryGroups: categoryGroups,
			transactionSubmit: this.transactionSubmit,
			categoryToNewTransaction: this.categoryToNewTransaction,
			categorySubmit: this.categorySubmit,
			categoryDelete: this.categoryDelete,
			categoryDeleteUndo: this.categoryDeleteUndo,
			categoryGroupSubmit: this.categoryGroupSubmit,
			categoryGroupDelete: this.categoryGroupDelete,
			categoryGroupDeleteUndo: this.categoryGroupDeleteUndo,
			transactionDelete: this.transactionDelete,
			saveAllUpdatedBudgetsForCategoryGroup: saveAllUpdatedBudgetsForCategoryGroup,
			submitBudgetUpdate: submitBudgetUpdate,
			submittingCategories,
			submittingCategoryGroups,
			submittingBudgets,
			submittingBudgetsForCategoryGroup,
			sizeMobile,
		};

		if(firstLoad) {
			return (
				<CircleLoader
					fullScreen={true}
					showLoaderAnimation={false}
				>
					<img
						className='pulse_item'
						src={`${siteUrl}/images/budget-icon192x192.png`} />
				</CircleLoader>
			);
		}

		const categoryGroupsByType = getAllCategoryGroupsHashedByType();

		const selectedMainTab = currentSlug(url[1]);
		const activeBudgetSubTab = url[2];
		const isOnBanksTab = activeBudgetSubTab === 'banks';

		const renderBudgetPageContent = () => {
			let useTabs = false;
			if(separateBudgetTabsFeatureActive) {
				useTabs = true;
			}

			let tabToDisplay = activeBudgetSubTab;
			let aCategoryBudgetIsSelected = Category.getTypes().some((categoryGroupType) => {
				return categoryGroupType.name.toLowerCase() === tabToDisplay;
			});

			if(!separateBudgetTabsFeatureActive && aCategoryBudgetIsSelected) {
				tabToDisplay = 'budgets';
			}

			const categoryDisplay = (
				Category.getTypes().map((categoryGroupType, index) => (
					<Tab
						key={categoryGroupType.id}
						label={categoryGroupType.name}
						icon={categoryGroupType.icon}
					>
						<CategoriesComponent
							{...categoryProps}
							showTotals={useTabs || (index === 0 && !useTabs)}
							shouldShowEditCategoryOptions={index === 0 || separateBudgetTabsFeatureActive}
							categoryGroupType={categoryGroupType}
							categoryGroupsByType={categoryGroupsByType}
							categoryType={categoryGroupType.id}
							transactionCategoryEdit={this.transactionCategoryEdit}
						/>
					</Tab>
				))
			);
			return (
				<div>
					{!useTabs &&
					<React.Fragment>
						{categoryDisplay}
					</React.Fragment>
					}
					{useTabs &&
					<Tabs
						tabsClasses='budget_tabs'
						activeTab={tabToDisplay}
						onTabChange={budgetSubTabChanged}
					>
						{separateBudgetTabsFeatureActive &&
						categoryDisplay
						}
						{!separateBudgetTabsFeatureActive &&
						<Tab label='Budgets'>
							{categoryDisplay}
						</Tab>
						}
					</Tabs>
					}
				</div>
			);
		};

		/**
		 * The app's sections, in nav order. `monthScoped` puts the month control in the header; only
		 * settings reads no month (the calendar draws the selected one). Settings also sits apart from
		 * the rest: at the foot of the sidebar, and in the header on a phone, where the bottom bar has
		 * no room for it.
		 */
		const sections = [
			{
				slug: 'budget', group: groupOfSlug('budget'), label: 'Budget', icon: 'attach_money', monthScoped: true,
				content: () => (
					<div className={`${sizeDesktop ? 'container' : ''}`}>
						<div className='row'>
							{!isOnBanksTab &&
							<div className='col s12'>
								<AmountRemainingToBudget />
							</div>
							}
							<div className='col s12 l12'>
								{renderBudgetPageContent()}
							</div>
						</div>
					</div>
				),
			},
			{
				slug: 'transactions', group: groupOfSlug('transactions'), label: 'Transactions', icon: 'credit_card', monthScoped: true, className: 'transactions_display',
				content: () => (
					<div className='row'>
						<div className={`${sizeDesktop ? 'container' : ''}`}>
							<div className=''>
								<Provider store={store}>
									<TransactionsSection
										showingBankAccountTransactionsWithinTransactions={showingBankAccountTransactionsWithinTransactions}
										transactionSubmit={this.transactionSubmit}
										transactionDelete={this.transactionDelete}
										transactionDeleteUndo={this.transactionDeleteUndo}
										transactionCategoryEdit={this.transactionCategoryEdit}
										lastEditedTransactionId={lastEditedTransactionId}
										categories={categories}
										submittingTransactions={submittingTransactions}
										transactionFinder={this.transactionFinder}
										highlightTransaction={this.highlightTransaction}
										deleteAllTransactionsPopupInitiate={this.deleteAllTransactionsPopupInitiate}
										{...this.state}
									/>
								</Provider>
							</div>
						</div>
					</div>
				),
			},
			{
				slug: 'accounts', group: groupOfSlug('accounts'), label: 'Accounts', icon: 'account_balance', monthScoped: true,
				content: () => (
					<div className='container'>
						<BanksSummary />
					</div>
				),
			},
			{
				slug: 'ledger', group: groupOfSlug('ledger'), label: 'Ledger', icon: 'grid_on', monthScoped: true, className: 'ledger',
				content: () => (
					<LedgerPage
						categoryGroupsByType={categoryGroupsByType}
						selectedDates={selectedDates}
						selectedDate={selectedDate}
						transactionFinder={this.transactionFinder}
						transactionSubmit={this.transactionSubmit}
					/>
				),
			},
			{
				slug: 'summary', group: groupOfSlug('summary'), label: 'Summary', icon: 'assignment', monthScoped: true, className: 'monthly_summary',
				content: () => (
					<div className={`${sizeDesktop ? 'container' : ''}`}>
						<MonthlySpendSummary
							selectedDate={selectedDate}
							selectedDates={selectedDates}
							categoryGroupsByType={categoryGroupsByType}
							{...this.state}
						/>
					</div>
				),
			},
			showCalendarTab && {
				slug: 'calendar', label: 'Food', icon: 'calendar_today', monthScoped: true, className: 'calendar',
				content: () => (
					<Provider store={store}>
						<CalendarPage />
					</Provider>
				),
			},
			{
				slug: 'settings', label: 'Settings', icon: 'settings', monthScoped: false, footer: true,
				content: () => (
					<div className={`${sizeDesktop ? 'container' : ''}`}>
						<div className='row'>
							<div className='col s12'>
								<Provider store={store}>
									<SettingsPage
										plaidAccounts={plaidAccounts}
										player={player}
									/>
								</Provider>
							</div>
						</div>
					</div>
				),
			},
		].filter(Boolean);
		const navSections = sections.filter((section) => !section.footer);
		const footerSections = sections.filter((section) => section.footer);
		const activeSection = sections.find((section) => section.slug === selectedMainTab) || sections[0];
		// Where the bottom bar's Money goes back to.
		if(activeSection.group) {
			this.lastVisited = { ...this.lastVisited, [activeSection.group]: activeSection.slug };
		}
		// On a phone, a group's sections are a strip of tabs above the page (sectionGroups.js); the
		// desktop sidebar lists them itself.
		const groupStrip = sizeDesktop ? [] : groupMembers(sections, activeSection);

		return (
			<React.Fragment>

				<DragDropContext
					onBeforeCapture={this.onBeforeCapture}
					onDragEnd={this.onDragEnd}
				>
					<LoginPagePopup />
					<ToastContainer
						position="bottom-right"
						autoClose={5000}
						hideProgressBar={false}
						newestOnTop={false}
						closeOnClick={false}
						closeButton={null}
						rtl={false}
						pauseOnFocusLoss
						draggable
						pauseOnHover
					/>
					<div className='dashboard'>
						<ToastHideBankTransactionUndo
						/>
						<BudgetSubmitUndo
						/>
						<TransactionEditUndo
							transactionSubmit={this.transactionSubmit}
						/>
						{deleteAllTransactionsPopup &&
						<SweetAlert
							icon={SweetAlert.icons.warning}
							onCancel={deleteAllTransactionsPopupEnd}
							onConfirm={deleteAllTransactionsGo}
							confirmButtonText='Delete All Transactions!'
							onClose={deleteAllTransactionsPopupEnd}
							confirmedText={`All ${selectedDate.format('MMMM')} ${selectedDate.format('YYYY')} Transactions Deleted`}
							confirmedTitle={'Transactions Deleted'}
							showCancelButton={true}
							showConfirmButton={true}
						>
							<div>
								Delete all stored transactions for{' '}
								<span className='date'>
								{selectedDate.format('MMMM')}{' '}
									{selectedDate.format('YYYY')}
							</span>
							</div>
						</SweetAlert>
						}
						<div className='app-shell'>
							{sizeDesktop &&
							<MainNav
								variant='sidebar'
								sections={navSections}
								footerSections={footerSections}
								activeSlug={activeSection.slug}
								onSelect={this.onTabClick}
								baseUrl={siteUrl}
							/>
							}
							<div className='app-main'>
								<AppHeader
									title={activeSection.label}
									showMonth={activeSection.monthScoped}
									trailing={(
										<div className='app-header__actions'>
											<WhatsNew />
											{!sizeDesktop &&
											<SectionLink
												slug='settings'
												label='Settings'
												icon='settings'
												active={activeSection.slug === 'settings'}
												onSelect={this.onTabClick}
												baseUrl={siteUrl}
												className='app-header__icon-link'
											/>
											}
										</div>
									)}
								/>
								<LoginWarning />
								<SyncStatus />
								{refreshingData &&
								<div className='refreshing_data progress'>
									<div className='indeterminate' />
								</div>
								}
								<Provider store={store}>
									<div className='main-content tab-content'>
										{groupStrip.length > 0 ?
										<Tabs
											activeTab={activeSection.slug}
											onTabChange={this.onTabClick}
											tabsClasses='section-group-tabs'
										>
											{groupStrip.map((section) => (
												<Tab key={section.slug} label={section.slug} content={section.label} icon={section.icon} className={section.className}>
													{section.slug === activeSection.slug && activeSection.content()}
												</Tab>
											))}
										</Tabs> :
										<div
											className={`${activeSection.className || ''} tab-content-inner active`}
											key={activeSection.slug}
											id={activeSection.slug}>
											{activeSection.content()}
										</div>
										}
									</div>
								</Provider>
							</div>
							{!sizeDesktop &&
							<MainNav
								variant='bottom'
								sections={navSections}
								activeSlug={activeSection.slug}
								onSelect={this.onTabClick}
								baseUrl={siteUrl}
								lastVisited={this.lastVisited}
							/>
							}
						</div>
					</div>
				</DragDropContext>
				{!!transactionBeingEdited &&
				<TransactionSummaryComponent
					{...categoryProps}
					key={transactionBeingEdited.instanceNumber}
					transaction={transactionBeingEdited}
					endTransactionEdit={endTransactionEditMode}
					addingForSpecificCategory={transactionBeingEditedCategoryLocked}
					editOnly={true}
					isEditModal={true}
					transactionCategoryEdit={this.transactionCategoryEdit}
					selectedDate={selectedDate}
					transactionBeingEditedModalShouldBeOpen={transactionBeingEditedModalShouldBeOpen}
				/>
				}
			</React.Fragment>
		);
	}
}


function mapStateToProps(state) {
	return {
		...state.dashboard,
		...state.settings,
		...state.windowSize,
		...state.plaid,
		...state.url,
	};
}

function mapDispatchToProps(dispatch) {
	return bindActionCreators({
		...calendarActions,
		...dashboardActions,
		...windowSizeActions,
		...plaidActions,
		...urlActions,
		reorderMealIdeaInGroup: mealIdeaActions.reorderMealIdeaInGroup,
		moveMealIdeaToGroup: mealIdeaActions.moveMealIdeaToGroup,
		addMealIdeaToGroup: mealIdeaActions.addMealIdeaToGroup,
		reorderMealIdeaIngredient: mealIdeaActions.reorderMealIdeaIngredient,
	}, dispatch);
}

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(DashboardPage);